import dayjs from "dayjs";
import "dayjs/locale/it";

dayjs.locale("it");

export const DAYS = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];
export const iso = (d) => dayjs(d).format("YYYY-MM-DD");
export const today = () => iso(dayjs());
const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);
export const nextSchoolDay = (from) => {
  let d = dayjs(from).add(1, "day");
  if (d.day() === 0) d = d.add(1, "day");
  return iso(d);
};
export const weekday = (d) => ((dayjs(d).day() + 6) % 7) + 1;
export const fmtLong = (s) => cap(dayjs(s).format("dddd D MMMM"));
export const fmtShort = (s) => cap(dayjs(s).format("ddd D MMM"));
export const fmtDateTime = (s) => dayjs(s).format("D MMM YYYY, HH:mm");
export const weekDates = (anchor) => {
  const monday = dayjs(anchor).subtract(weekday(anchor) - 1, "day");
  return DAYS.map((_, i) => iso(monday.add(i, "day")));
};
export const addDays = (s, n) => iso(dayjs(s).add(n, "day"));
export const isPast = (s) => s < today();
export { dayjs };
